// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"5715a6d0","484":"173d8876","988":"974b4c8a"}[chunkId] + ".chunk.js";
};